/**
 * теперь этот файл/поток будет кодироваться в UTF-8
 */
import {BlogListFilter} from "./BlogListFilter";
import BlogService from "../../../services/BlogService";
import {BlogList} from "./BlogList";
import {CustomSelect} from "./customSelect";
export default {
    components: {
        BlogListFilter,
        BlogList,
        CustomSelect
    },
    data() {
        return {
            items: [],
            currentPage: 1,
            limit: 4,
            totalPages: 0,
            tags: [],
            selectedTagId: 'blog',
            selectedSorting: 'Сначала последние',
            sorting: [
                {
                    'id': 'desc',
                    'name': 'Сначала последние',
                },
                {
                    'id': 'asc',
                    'name': 'Сначала ранние',
                },
            ],
        };
    },
    methods: {

        async getItems() {
            const { items, pages } = await BlogService.all(this.limit,this.currentPage);
            if (!items) this.items = [];
            this.items = items;
            this.totalPages = pages;
        },

        async getItemsByTag() {
            let sorting = (this.selectedSorting != 'asc' && this.selectedSorting != 'desc') ? 'desc': this.selectedSorting;
            const { items, pages } = await BlogService.byTag(this.selectedTagId,this.limit,this.currentPage,sorting);
            if (!items) this.items = [];
            this.items = items;
            this.totalPages = pages;
        },
        async getTags() {
            const { tags } = await BlogService.tags();
            this.tags = tags;
        },
        changeTag(tag) {
            this.selectedTagId = tag;
        },
        changePage(pageNumber){
            this.currentPage = pageNumber;
        },
        minusPage() {
            if (this.currentPage > 1) this.currentPage--;
        },
        plusPage(){
            if (this.currentPage < this.totalPages) this.currentPage++;
        }


    },
    mounted() {
        if (this.selectedTagId !== '') {
            this.getItemsByTag();
        } else {
            this.getItems();
        }
        this.getTags();
    },

    watch: {
       currentPage() {
           if (this.searchQuery !== '') {
               this.getItemsBySearch();
           } else if (this.selectedTagId !== '') {
               this.getItemsByTag();
           } else {
               this.getItems();
           }
       },
        selectedTagId() {
           if (this.selectedTagId !== '') {
               this.getItemsByTag();
           } else {
               this.getItems();
           }

        },
        selectedSorting(){
            this.getItemsByTag();
        }
    },
    template: `
            <section class="blog__news">
                <div class="container">
                 
                    <div class="blog__news--filters">
                        <BlogListFilter @selectedTag="changeTag" :tags="tags" :selected="selectedTagId"/>
                        
                          <CustomSelect
                              :options="sorting"  
                              v-model="selectedSorting"
                          />
                    </div> 
                    
                    <BlogList 
                        @changePage="changePage"
                        @minusPage="minusPage"
                        @plusPage="plusPage"
                        :items="items" 
                        :total="totalPages" 
                        :currentPage="currentPage" 
                    />
              
                </div>
            
            </section>
        `,
};
